import { render, staticRenderFns } from "./PmcPopup.vue?vue&type=template&id=fb5aca28&scoped=true&"
import script from "./PmcPopup.vue?vue&type=script&lang=js&"
export * from "./PmcPopup.vue?vue&type=script&lang=js&"
import style0 from "./PmcPopup.vue?vue&type=style&index=0&id=fb5aca28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb5aca28",
  null
  
)

export default component.exports